import React from "react";

import "./MediaTest.scss";

function MediaTest() {
  return (
    <div className="media-test">
      <div className="phone-landscape">phone landscape</div>
      <div className="phone-portrait">phone portrait</div>
      <div className="tablet">tablet</div>
      <div className="desktop">desktop</div>
    </div>
  );
}

export default MediaTest;
